import routes from '@th/shared/src/constants/routes';
import createDeepLink from '@th/shared/src/helpers/deepLinkCreators/createDeepLink';

export default function createSigninWithEmailDeepLink(
  email: string,
  agentSlug?: string,
): string {
  const deepLink = new URL(
    createDeepLink(routes.signinConfirmEmail, { agentSlug }),
  );
  deepLink.searchParams.set('email', email);
  return deepLink.toString();
}
